import { FC, MouseEvent } from "react";
import { Box, createStyles, makeStyles } from "@material-ui/core";

import { Image, Modal } from "components";
import ParagraphContent from "components/Modal/ParagraphContent";
import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      "& img": {
        height: 20,
        margin: "0 5px 5px 0",
      },
    },
  }),
);

export const MarketplaceMedian: FC = () => (
  <ParagraphContent
    paragraphs={[
      "The Marketplace Median price for a listing is developed based on the median multiple paid for other catalogs within a similar Dollar Age range.",
      "The price is not based upon an individual analysis of the particulars of the specific catalog. The actual value of the catalog could be higher or lower depending on a number of qualitative factors not included in the formulation of the Marketplace Median price.",
      "The Marketplace Median price is meant to aid in the formulation of your own offer. As always, do your own due diligence.",
    ]}
  />
);

export const MarketplaceMedianTitle: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.title}>
      <Image name="re-mark-dark.png" />
      <span>Marketplace Median</span>
    </Box>
  );
};

interface MarketplaceMedianModalProps {
  open: boolean;
  onClose: (e: MouseEvent) => void;
}

const MarketplaceMedianModal: FC<MarketplaceMedianModalProps> = props => (
  <Modal
    title={<MarketplaceMedianTitle />}
    {...props}
    maxWidth="sm"
    style={{ maxWidth: theme.breakpoints.width("sm"), margin: "auto" }}
  >
    <MarketplaceMedian />
  </Modal>
);

export default MarketplaceMedianModal;
